import { lazy } from "react";

export const OnboardingThankyouScreenLazyComponent = lazy(() =>
  import(
    "features/Onboarding/modules/OnboardingThankyouScreen/OnboardingThankyouScreen"
  )
);

export const OnboardingQuestionsLazyComponent = lazy(() =>
  import("features/Onboarding/modules/OnboardingQuestions/OnboardingQuestions")
);

export const FunnelTemplateSelectionLazyComponent = lazy(() =>
  import(
    "features/Onboarding/modules/OnboardingFunnels/modules/FunnelTemplateSelection/FunnelTemplateSelection"
  ).then((module) => ({ default: module.FunnelTemplateSelection }))
);

export const FunnelDetailsModalLazyComponent = lazy(() =>
  import(
    "features/Onboarding/modules/OnboardingFunnels/modules/FunnelTemplateSelection/modules/FunnelDetails/modules/FunnelDetailsModal/FunnelDetailsModal"
  ).then((module) => ({ default: module.FunnelDetailsModal }))
);

export const FunnelDetailsMobileScreenLazyComponent = lazy(() =>
  import(
    "features/Onboarding/modules/OnboardingFunnels/modules/FunnelTemplateSelection/modules/FunnelDetails/modules/FunnelDetailsMobileScreen/FunnelDetailsMobileScreen.jsx"
  ).then((module) => ({ default: module.FunnelDetailsMobileScreen }))
);

export const SelectedFunnelDetailsModalLazyComponent = lazy(() =>
  import(
    "features/Onboarding/modules/OnboardingFunnels/modules/FunnelTemplateSelection/modules/FunnelDetails/modules/SelectedFunnelDetails/modules/SelectedFunnelDetailsModal/SelectedFunnelDetailsModal.jsx"
  ).then((module) => ({ default: module.SelectedFunnelDetailsModal }))
);
